// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ZYgP","search":"Settings_search__3clzv","filter":"Settings_filter__chKJB"};